import styled from 'styled-components';
import {dFlex, dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const infoContainer = styled.div`
    margin-bottom: var(--space-lg);
`;

export const info = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    ${dFlexColumn};
    gap: var(--space-lg);
    padding-inline: var(--space-xl);
    white-space: pre-line;
`;

export const infoItem = styled.div`
    ${dFlex};
    gap: var(--space-sm);
    padding-inline: var(--space-xl);
`;

export const infoTitle = styled.span`
    font-size: var(--font-size-h4);
    font-weight: var(--font-weight-bold);
`;

export const infoValue = styled.span`
    font-size: var(--font-size-h4);
`;
